<div class="router-icon flex-center" [style.width.px]="size" [style.height.px]="size"
	 [style.border-radius.px]="size / 4">
	<img [width]="router.type === 'router' ? size * 0.7 : size * 0.5" [src]=" router.type === 'router' ? 'assets/icons/router.svg' : 'assets/icons/firewall.svg'" class="filter-accent"
		 alt="">
</div>
